<template>
    <div class="content-box">
        <Title/>

        <Echarts/>
    </div>
</template>

<script>
export default {
    name: "industry",
    data() {
        return {
            params: {
                dataNav: [
                    {
                        name: "交易规模",
                        data: "shares",
                        unit: "亿元"
                    },
                    {
                        name: "用户规模",
                        data: "a100",
                        unit: "亿人"
                    },
                    {
                        name: "渗透率",
                        data: "a101",
                        unit: "％"
                    },
                    {
                        name: "在线旅游市场GMV",
                        data: "a125",
                        unit: "亿元"
                    },
                    {
                        name: "融资事件数量",
                        data: "a129",
                        unit: "次"
                    },
                    {
                        name: "融资金额",
                        data: "a130",
                        unit: "亿元"
                    },
                    {
                        name: "出境旅游人数",
                        data: "a139",
                        unit: "百万"
                    },
                    {
                        name: "出国留学人数",
                        data: "a140",
                        unit: "万人"
                    },
                    {
                        name: "留学人员回国人数",
                        data: "a141",
                        unit: "万人"
                    },
                    {
                        name: "国内旅游总人数",
                        data: "a151",
                        unit: "亿人"
                    },
                    {
                        name: "国内旅游总收入",
                        data: "a152",
                        unit: "万亿元"
                    },
                ],
                name: '在线旅游'
            }
        }
    },
    created() {
        this.$store.dispatch('getIndustry', this.params)
    },
}
</script>